import { graphql } from '@teachino/shared-infrastructure';

export const syncTopicInfoFromTopicTemplateMutation = graphql(`
  mutation syncTopicInfoFromTopicTemplate($topicId: String!) {
    syncTopicWithTemplate(
      topicTemplateSyncInput: { id: $topicId, syncMode: SINGLE }
    ) {
      done
    }
  }
`);
